module.exports = __webpack_public_path__ + "media/styles/images/png/select-gray-dark-a8d0e3751dcbbfb22356b3d0d6521ebd.png";